import api from '../../axios_api'
import _ from 'lodash'
import Promise from 'bluebird'
import router from '../../main'


const state = {
    server_data: [],
    allChecklist:[]
}

const getters = {
    checklistByPortfolioId: (state) => (id) => {
        let data = _.filter(state.server_data, function (o) { return (o.portfolio_item === id) }) || []
        return data;
    },
    allChecklistData:state=>state.allChecklist
}

const mutations = {
    initialize(state) {
        state.server_data = []
        state.allChecklist=[]
    },
    setAllChecklist:(state, data)=>{
        state.allChecklist=data
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        state.server_data = _.map(state.server_data, addr => {
            let index = _.findIndex(payload, function (a) { return a._id === addr._id })
            if (index >= 0) {
                return _.first(_.pullAt(payload, index))
            }
            return addr
        })
        if (!_.isEmpty(payload)) state.server_data = _.concat(state.server_data, payload)
        state.server_data = _.without(state.server_data, null, undefined)

        state.server_data = state.server_data.sort(function compare(a, b) {
            var dateA = new Date(a.created);
            var dateB = new Date(b.created);
            return dateB - dateA;
        });
    },
    remove(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        // remove the item by the id (either _id or uaid)
        state.server_data = _.filter(state.server_data, function (a) { return a._id !== payload && a.uaid !== payload })
    }
}
const actions = {
    start({ state, dispatch, commit }) {
        commit('initialize')
        dispatch('apiFetchChecklist');
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    cycle({ }) { },
    apiFetchChecklist({ commit }) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user

            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `${fiifi.id}/${fiifi.workspace_id}/checklist`;
                return api.get(url)
                    .then(res => {
                        commit('merge', res.data.encrypt.success);
                        return Promise.resolve(res.data.encrypt.success)
                    })
                    .catch(err => {
                        console.error(`Error during rounds fetch: ${err}`)
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiFetchAllChecklist({ commit }) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user

            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `${fiifi.id}/checklists`;
                return api.get(url)
                    .then(res => {
                        commit('setAllChecklist', res.data.encrypt.success);
                        return Promise.resolve(res.data.encrypt.success)
                    })
                    .catch(err => {
                        console.error(`Error during rounds fetch: ${err}`)
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiPostChecklist({ commit, dispatch }, payload) {
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/${payload.portfolio_item}/checklist`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                commit('merge', res.data.encrypt.success)
                dispatch('apiFetchChecklist');
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                console.error(`Error during rounds post: ${err}`)
                return Promise.reject(err)
            })
    },
    apiPatchChecklist({ commit, dispatch }, payload) {
        let url = `${router.currentRoute.params.account_id}/${payload._id}/checklist`;
        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                commit('merge', res.data.encrypt.success)
                dispatch('apiFetchChecklist');
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                console.error(`Error during rounds Patch: ${err}`)
                return Promise.reject(err)
            })

    },
    apiDeleteChecklist({ commit }, id) {
        commit('remove', id)
        return Promise.resolve([]);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}